import { apiFetch } from './client';

export const getDecisions = (params = {}) =>
  apiFetch(`/api/decisions?${new URLSearchParams(params)}`);

export const updateDecision = (id, body) =>
  apiFetch(`/api/decisions/${id}`, { method: 'PATCH', body: JSON.stringify(body) });
